<template>
  <div class="containerOfAll">
    <div class="controlStuff">
      <div class="gameData">
        <p> Enemy List:</p>
        <ul>
          <li v-for="enemy in enemies" :key="enemy">
            Enemy's speed:<br>
            <em>{{ enemy.enemySpeed*5}} tiles per second</em><br>
            Chance enemy fires every 0.1s:<br>
            <em>{{ enemy.chanceToFire*100 }}%</em>
          </li>
        </ul>
        <p >Enemies Hit : <span>{{enemiesHit}}</span></p>
        <p :style="playerHitBGCSS">Player Hit ? <span>{{playerHit}}</span></p>
        <p :style="playerBulletCooldownTimerBGCSS">Player Bullet Cooldown : <span>{{playerBulletCooldown}}</span> units</p>
      </div>
      <br>
      <div class="instructionsForGS">
        <p>
          Controls for moving the Spaceship in the canvas on the left:<br>
          - use arrow keys<br>
          - use arrow buttons below<br><br>

          Controls for firing a bullet from the spaceship:<br>
          - press "j"<br>
          - use button below
        </p>
      </div>
      <div class="controlButtons">
        <button type="button" ref="leftButt" @mousedown="buttondownHandler" @mouseup="buttonupHandler">⯇</button>
        <button type="button" ref="upButt" @mousedown="buttondownHandler" @mouseup="buttonupHandler">⯅</button>
        <button type="button" ref="downButt" @mousedown="buttondownHandler" @mouseup="buttonupHandler">⯆</button>
        <button type="button" ref="rightButt" @mousedown="buttondownHandler" @mouseup="buttonupHandler">⯈</button>

        <button type="button" ref="fireButt" @mousedown="buttondownHandler" @mouseup="buttonupHandler">Fire Bullet (j)</button>
      </div>
      <div class="controlButtons">
        <button type="button" ref="restartGameButt" @click="gameRestart" style="background-color: orangered; border-radius: 5%;">Restart Game</button>
      </div>
    </div>

    <div class="leftStuff">
      <canvas class="gamescreen" ref="gs" >
        <p>Uh Oh, You do not have canvas support. Try a different browser</p>
      </canvas>
      <canvas class="UIscreen" ref="uis" >
        <p>Uh Oh, You do not have canvas support. Try a different browser</p>
      </canvas>
    </div>
  </div>
</template>

<script>
//import classes
import PlayerCharacter from "@/components/PlayerCharacter"
import BackgroundImage from "@/components/BackgroundImage"
import ImageLoadCounter from "@/components/imageloadcounter"
import Bullet from "@/components/Bullet"
import EnemyShip from "@/components/EnemyShip"

//import images
import PlayerShipImage from "./assets/playerSpaceship.png"
import PlayerBulletImage from "./assets/playerbullet.png"
import SpaceBackground from "./assets/spacebackground.png"
import PlanetsBackgroundLayer from "./assets/planetsbackgroundlayer.png"
import EnemyBulletImage from "./assets/enemybullet.png"
import EnemyShipImage from "./assets/enemyShip0.png"
import ExplosionImage from "./assets/explosion.png"
import LazerXCutoffShipImage from "./assets/cutoffLazerShip.png"
import LazerXCutoffShipDeactivatedImage from "./assets/cutoffLazerShipDeactivated.png"
import LazerXCutoffBeamImage from "./assets/cutoffLazerSlice.png"

//import UI images
import GameOverUIImage from "./assets/gameoverUI.png"

//background variables
let canvasBackgroundImgs = [];

let imageloadcounter = new ImageLoadCounter(1000);

const playerShipImg = new Image();
let pc = new PlayerCharacter();
const canvasTilePerSide = 15;
const tileFractionPerPlayerMove = 0.2;
const tilesize = (window.innerHeight < window.innerWidth ? window.innerHeight*0.9/canvasTilePerSide : window.innerWidth*0.9/canvasTilePerSide);

let keysPressed = []; //store keys pressed after keydown, remove after keyup/onblur
const bulletSize = 0.5; //size of bullet relative to 1 tile on canvas
let bullets = []; //store bullets on screen, remove after bullet exists canvas (aka bulletCoords[1] === 0-bulletTilelLength)
let bulletFiredByPress = false;
const playerBulletImg = new Image();
const BULLET_FULL_COOLDOWN = 3000;
const BULLET_COOLDOWN_ADD_PER_FIRE = 600;

//enemy
const enemyShipImg = new Image();
const enemyBulletImg = new Image();
const xCutoffLazerShipImg = new Image();
const xCutoffLazerShipDeactivatedImg = new Image();
const xCutoffLazerBeamImg = new Image();
const explosionImg = new Image();

//UI Images
const gameOverOverlay = new Image();

export default {
  data(){
    return{
      playerBulletCooldown : 0,
      playerBulletLock : false,
      playerHit : false,
      enemiesHit : 0,

      //list of enemies
      enemies : [new EnemyShip(enemyShipImg, (canvasTilePerSide-1)/2, 5*Math.random(), 0, 0.1 + 0.1*Math.random(), 0.1 + 0.1*Math.random()),
                  new EnemyShip(xCutoffLazerShipDeactivatedImg, (2*Math.random() < 1) ? 1+(canvasTilePerSide/4)*Math.random(): (canvasTilePerSide-2)-(canvasTilePerSide/4)*Math.random(), 0, 1, 0, 0.1 + 0.1*Math.random())]
    }
  },
  mounted() {
    let vue = this;

    //console.log("mounted")
    playerShipImg.onload = function () {
      imageloadcounter.imgsloaded++
      if(imageloadcounter.imgsloaded >= imageloadcounter.imgsToLoad) vue.initFirstDraw();
    }
    playerShipImg.src = PlayerShipImage;

    playerBulletImg.onload = function () {
      imageloadcounter.imgsloaded++
      if(imageloadcounter.imgsloaded >= imageloadcounter.imgsToLoad) vue.initFirstDraw();
    }
    playerBulletImg.src = PlayerBulletImage;

    enemyBulletImg.onload = function () {
      imageloadcounter.imgsloaded++
      if(imageloadcounter.imgsloaded >= imageloadcounter.imgsToLoad) vue.initFirstDraw();
    }
    enemyBulletImg.src = EnemyBulletImage;

    enemyShipImg.onload = function () {
      imageloadcounter.imgsloaded++
      if(imageloadcounter.imgsloaded >= imageloadcounter.imgsToLoad) vue.initFirstDraw();
    }
    enemyShipImg.src = EnemyShipImage;

    xCutoffLazerShipImg.onload = function () {
      imageloadcounter.imgsloaded++
      if(imageloadcounter.imgsloaded >= imageloadcounter.imgsToLoad) vue.initFirstDraw();
    }
    xCutoffLazerShipImg.src = LazerXCutoffShipImage;

    xCutoffLazerShipDeactivatedImg.onload = function () {
      imageloadcounter.imgsloaded++
      if(imageloadcounter.imgsloaded >= imageloadcounter.imgsToLoad) vue.initFirstDraw();
    }
    xCutoffLazerShipDeactivatedImg.src = LazerXCutoffShipDeactivatedImage;

    xCutoffLazerBeamImg.onload = function () {
      imageloadcounter.imgsloaded++
      if(imageloadcounter.imgsloaded >= imageloadcounter.imgsToLoad) vue.initFirstDraw();
    }
    xCutoffLazerBeamImg.src = LazerXCutoffBeamImage;

    explosionImg.onload = function () {
      imageloadcounter.imgsloaded++
      if(imageloadcounter.imgsloaded >= imageloadcounter.imgsToLoad) vue.initFirstDraw();
    }
    explosionImg.src = ExplosionImage;

    gameOverOverlay.onload = function () {
      imageloadcounter.imgsloaded++
      if(imageloadcounter.imgsloaded >= imageloadcounter.imgsToLoad) vue.initFirstDraw();
    }
    gameOverOverlay.src = GameOverUIImage;

    window.addEventListener('keydown', this.keydownHandler);
    window.addEventListener('keyup', this.keyupHandler);
    window.addEventListener('blur', this.onblurHandler);

    //add canvas backgrounds
    canvasBackgroundImgs.push(new BackgroundImage(null, 2560-512, 1, 512, imageloadcounter));
    canvasBackgroundImgs.push(new BackgroundImage(null, 7168-512, 2, 512, imageloadcounter));
    //add onloads
    for (let i = 0; i < canvasBackgroundImgs.length; i++) {
      canvasBackgroundImgs[i].backgroundImage.onload = function (){
        imageloadcounter.imgsloaded++
        if(imageloadcounter.imgsloaded >= imageloadcounter.imgsToLoad) vue.initFirstDraw();
      }
    }
    //update imageloadcounter
    imageloadcounter.imgsToLoad = 9 + canvasBackgroundImgs.length;
    //actually set the srcs now
    canvasBackgroundImgs[0].backgroundImage.src = SpaceBackground;
    canvasBackgroundImgs[1].backgroundImage.src = PlanetsBackgroundLayer;

    //misc 1/100s timer function to update stuff in dom
    this.timer = setInterval(() => {
      //this.playerBulletCooldown = (playerBulletWaitTime - ((new Date()).getTime() - lastBulletFiredTime) > 0) ? playerBulletWaitTime - ((new Date()).getTime() - lastBulletFiredTime) : 0;
    }, 10)

  },
  beforeUnmount() {
    clearInterval(this.timer);
  },
  computed: {
    playerBulletCooldownTimerBGCSS: {
      get() {
        return (this.playerBulletLock) ? {background: 'DarkRed'} : {background: 'green'};
      },
    },
    playerHitBGCSS: {
      get() {
        return (this.playerHit) ? {background: 'DarkRed'} : {background: 'green'};
      },
    },
  },
  methods: {
    keydownHandler(event){
      if (keysPressed.indexOf(event.key)===-1) keysPressed.push(event.key);
    },
    keyupHandler(event){
      if (keysPressed.indexOf(event.key)!==-1) keysPressed.splice(keysPressed.indexOf(event.key),1);

      if(event.key === "j") bulletFiredByPress = false;
    },
    buttondownHandler(event){
      if(event.target === this.$refs.leftButt && keysPressed.indexOf("ArrowLeft") === -1){
        keysPressed.push("ArrowLeft");
      }
      if(event.target === this.$refs.rightButt && keysPressed.indexOf("ArrowRight") === -1){
        keysPressed.push("ArrowRight");
      }
      if(event.target === this.$refs.upButt && keysPressed.indexOf("ArrowUp") === -1){
        keysPressed.push("ArrowUp");
      }
      if(event.target === this.$refs.downButt && keysPressed.indexOf("ArrowDown") === -1){
        keysPressed.push("ArrowDown");
      }

      if(event.target === this.$refs.fireButt && keysPressed.indexOf("j") === -1){
        keysPressed.push("j");
      }
    },
    buttonupHandler(event){
      if(event.target === this.$refs.leftButt && keysPressed.indexOf("ArrowLeft") !== -1){
        keysPressed.splice("ArrowLeft",1);
      }
      if(event.target === this.$refs.rightButt && keysPressed.indexOf("ArrowRight") !== -1){
        keysPressed.splice("ArrowRight",1);
      }
      if(event.target === this.$refs.upButt && keysPressed.indexOf("ArrowUp") !== -1){
        keysPressed.splice("ArrowUp",1);
      }
      if(event.target === this.$refs.downButt && keysPressed.indexOf("ArrowDown") !== -1){
        keysPressed.splice("ArrowDown",1);
      }

      if(event.target === this.$refs.fireButt && keysPressed.indexOf("j") !== -1){
        keysPressed.splice("j",1); bulletFiredByPress = false;
      }
    },
    onblurHandler(){
      keysPressed = []; //clear all keys pressed
    },
    playerEventHandler(){
      //up down left right for player controlled character
      if (keysPressed.indexOf("ArrowLeft") !== -1) {
        pc.playerCoords[0] -= tileFractionPerPlayerMove;
        if(pc.playerCoords[0] <= 0) pc.playerCoords[0] = 0;
      }
      if (keysPressed.indexOf("ArrowRight") !== -1) {
        pc.playerCoords[0] += tileFractionPerPlayerMove;
        if(pc.playerCoords[0] >= canvasTilePerSide-1) pc.playerCoords[0] = canvasTilePerSide-1;
      }
      if (keysPressed.indexOf("ArrowUp") !== -1) {
        pc.playerCoords[1] -= tileFractionPerPlayerMove;
        if(pc.playerCoords[1] <= 0) pc.playerCoords[1] = 0;
      }
      if (keysPressed.indexOf("ArrowDown") !== -1) {
        pc.playerCoords[1] += tileFractionPerPlayerMove;
        if(pc.playerCoords[1] >= canvasTilePerSide-1) pc.playerCoords[1] = canvasTilePerSide-1;
      }
      //console.log(pc.playerCoords[0] + " " + pc.playerCoords[1])
    },
    playerBulletEventHandler(){
      //method to run every 1/50s to check for bullet being fired
      if (!this.playerBulletLock && keysPressed.indexOf("j") !== -1 && !bulletFiredByPress) {
        bullets.push(new Bullet(playerBulletImg, pc.playerCoords[0]+(1-bulletSize)/2, pc.playerCoords[1]-bulletSize, 0, 0.1))
        bulletFiredByPress = true; this.playerBulletCooldown += BULLET_COOLDOWN_ADD_PER_FIRE;
        this.playerBulletLock = this.playerBulletCooldown >= BULLET_FULL_COOLDOWN;
      }
    },
    bulletDrawer(){
      //console.log(bullets);
      for (let i = 0; i < bullets.length; i++) {
        const currBullet = bullets[i];
        let cvn = this.$refs.gs;
        if(currBullet.bulletType === 0) cvn.getContext("2d").drawImage(currBullet.bulletSprite,tilesize*currBullet.bulletCoords[0], tilesize*currBullet.bulletCoords[1], bulletSize*tilesize, bulletSize*tilesize);
        if(currBullet.bulletType === 1)cvn.getContext("2d").drawImage(currBullet.bulletSprite,tilesize*currBullet.bulletCoords[0], tilesize*currBullet.bulletCoords[1], tilesize, tilesize);
      }
    },
    bulletPlayerCollide(){
      //return true if a bullet has collided with the PC
      for (let i = 0; i < bullets.length; i++) {
        const currBullet = bullets[i];
        if ((pc.playerCoords[0] - currBullet.bulletCoords[0] < bulletSize && currBullet.bulletCoords[0] - pc.playerCoords[0] < 1)
            && (pc.playerCoords[1] - currBullet.bulletCoords[1] < bulletSize && currBullet.bulletCoords[1] - pc.playerCoords[1] < 1)) {
          if(currBullet.bulletType !== 1) bullets.splice(i, 1);
          pc.sprite = explosionImg;
          return true;
        }
      }
      return false;
    },
    bulletEnemyCollide(){
      //return true if a bullet has collided with the PC
      for (let i = 0; i < bullets.length; i++) {
        for(let j = 0; j < this.enemies.length; j++) {
          if(i < bullets.length){
            const currBullet = bullets[i];
            const currEnemy = this.enemies[j];
            if(!currEnemy.hit
                && (currEnemy.enemyCoords[0] - currBullet.bulletCoords[0] < bulletSize && currBullet.bulletCoords[0] - currEnemy.enemyCoords[0] < 1)
                && (currEnemy.enemyCoords[1] - currBullet.bulletCoords[1] < bulletSize && currBullet.bulletCoords[1] - currEnemy.enemyCoords[1] < 1)) {
              currEnemy.enemySprite = explosionImg;
              currEnemy.hit = true;
              this.enemiesHit++;
              if(currBullet.bulletType !== 1) bullets.splice(i, 1);
            }
          }
        }
      }
    },
    enemyPostHitCuller(){
      //countdown enemy's postHitCountdown by 1 every 1/100s
      // when countdown is <= 0, remove enemy from enemy array
      for(let j = 0; j < this.enemies.length; j++){
        const currEnemy = this.enemies[j];
        if(currEnemy.hit){
          if(currEnemy.postHitCountdown > 0) {
            currEnemy.postHitCountdown--;
          }
          else {
            this.enemies.splice(j,1);
            j--;
          }
        }
      }
    },
    enemyMover(){
      for(let i = 0; i < this.enemies.length; i++){
        const currEnemy = this.enemies[i];
        if(!currEnemy.hit) {
          if(currEnemy.enemyType === 0) {
            if (!(currEnemy.enemyCoords[0] === pc.playerCoords[0])) {
              if (Math.abs(currEnemy.enemyCoords[0] - pc.playerCoords[0]) < currEnemy.enemySpeed) currEnemy.enemyCoords[0] += pc.playerCoords[0] - currEnemy.enemyCoords[0];
              else currEnemy.enemyCoords[0] += (currEnemy.enemyCoords[0] < pc.playerCoords[0]) ? currEnemy.enemySpeed : -currEnemy.enemySpeed
            }
            if (currEnemy.enemyCoords[0] >= canvasTilePerSide - 1) currEnemy.enemyCoords[0] = canvasTilePerSide - 1;
            if (currEnemy.enemyCoords[1] >= canvasTilePerSide - 1) currEnemy.enemyCoords[1] = canvasTilePerSide - 1;
            if (currEnemy.enemyCoords[0] <= 0) currEnemy.enemyCoords[0] = 0;
            if (currEnemy.enemyCoords[1] <= 0) currEnemy.enemyCoords[1] = 0;
          }
        }
      }
    },
    enemyFire(){
      for(let i = 0; i < this.enemies.length; i++){
        const currEnemy = this.enemies[i];
        if(currEnemy.enemyType === 0) {
          const randNum = Math.random();
          if (!currEnemy.hit && randNum < currEnemy.chanceToFire) {
            bullets.push(new Bullet(enemyBulletImg, currEnemy.enemyCoords[0] + (1 - bulletSize) / 2, currEnemy.enemyCoords[1] + 1, 0, -0.15))
          }
        }
        if(currEnemy.enemyType === 1){
          const randNum = Math.random();
          if(!currEnemy.hit && currEnemy.chanceToFire > 0 && randNum < currEnemy.chanceToFire){
            for(let j = 0; j < canvasTilePerSide; j++){
              let newLazerPiece = new Bullet(xCutoffLazerBeamImg, currEnemy.enemyCoords[0], currEnemy.enemyCoords[1]+1+j, 1,0)
              bullets.unshift(newLazerPiece);
            }
            currEnemy.enemySprite = xCutoffLazerShipImg;
            currEnemy.chanceToFire = -currEnemy.chanceToFire;
          }
          else if (!currEnemy.hit && currEnemy.chanceToFire < 0 && randNum < -currEnemy.chanceToFire){
            for(let j = 0; j < bullets.length; j++){
              if(bullets[j].bulletType === 1) {bullets.splice(j,1); j--}
            }
            currEnemy.enemySprite = xCutoffLazerShipDeactivatedImg;
            currEnemy.chanceToFire = -currEnemy.chanceToFire;
          }
        }
      }
    },
    enemyDrawer(){
      for(let i = 0; i < this.enemies.length; i++){
        const cvn = this.$refs.gs;
        const currEnemy = this.enemies[i];
        cvn.getContext("2d").drawImage(currEnemy.enemySprite, tilesize*currEnemy.enemyCoords[0], tilesize*currEnemy.enemyCoords[1], tilesize, tilesize);
      }
    },
    async enemySpawner(){
      //insert logic here to spawn enemies
      let enemyTypeList = [];
      for (let i = 0; i < this.enemies.length; i++) enemyTypeList.push(this.enemies[i].enemyType);

      if(!enemyTypeList.includes(1)){
        let xCutoffPos = (2*Math.random() < 1) ? 1+(canvasTilePerSide/4)*Math.random(): (canvasTilePerSide-2)-(canvasTilePerSide/4)*Math.random()
        let newEnemy = new EnemyShip(xCutoffLazerShipDeactivatedImg, xCutoffPos, 0, 1, 0, 0.1 + 0.1*Math.random());
        this.enemies.push(newEnemy);

      }
      if(!enemyTypeList.includes(0)){
        let newEnemyXOffset = (2*Math.random() < 1) ? (canvasTilePerSide/4)*Math.random(): (-canvasTilePerSide/4)*Math.random()
        let newEnemy = new EnemyShip(enemyShipImg, pc.playerCoords[0]+newEnemyXOffset, 5*Math.random(), 0, 0.1 + 0.1*Math.random(), 0.1 + 0.1*Math.random())
        this.enemies.push(newEnemy);
        //enemy takes first shot
        bullets.push(new Bullet(enemyBulletImg, newEnemy.enemyCoords[0]+(1-bulletSize)/2, newEnemy.enemyCoords[1]+1, -0.15));

      }

    },
    initFirstDraw(){
      //add code to do before first draw

      pc.playerCoords = [(canvasTilePerSide-1)/2, canvasTilePerSide-1];
      pc.sprite = playerShipImg;

      //regularly scroll background every 1/100s
      this.timer = setInterval(() => {
        if(!pc.hit) {
          for (let i = 0; i < canvasBackgroundImgs.length; i++) {
            let currentBGIMG = canvasBackgroundImgs[i];
            if (currentBGIMG.backgroundY === 0) currentBGIMG.backgroundY = currentBGIMG.startingY;
            currentBGIMG.backgroundY -= currentBGIMG.decrementPerFrame; //scroll the background by backgroundYDecPerFrame every 1/100 sec
          }
        }
      }, 10)

      //every 1/50s, move player based on what's in the keysPressed array
      this.timer = setInterval(() => {if(!pc.hit) this.playerEventHandler() } , 20)

      // Bullet Timers
      //every 1/100s, move bullets along Y direction by margin specified in .bulletSpeed & detect if bullet hit player/enemies
      this.timer = setInterval(() => {
        if(!pc.hit) {
          for (let i = 0; i < bullets.length; i++) {
            //if a bullet Y coord <= 0-bulletSize && bullet moves up, remove bullet from bullet list
            if (bullets[i].bulletSpeed >= 0 && bullets[i].bulletCoords[i] <= 0 - bulletSize) bullets.splice(i, 1);
            //else if a bullet Y coord >= tilesPerSide+bulletSize && bullet moves down, remove bullet from bullet list
            else if (bullets[i].bulletSpeed <= 0 && bullets[i].bulletCoords[i] >= canvasTilePerSide + bulletSize) bullets.splice(i, 1);
            //else decrement Y thing if i within range
            else if (i < bullets.length) bullets[i].bulletCoords[1] -= bullets[i].bulletSpeed;
          }
          //detect if bullet hit player
          pc.hit = this.bulletPlayerCollide();
          if (!this.playerHit) this.playerHit = pc.hit;
          //detect bullets hitting enemies
          this.bulletEnemyCollide();
        }
      }, 10)
      //every 1/50s, check for bullet fire
      this.timer = setInterval(() => {if(!pc.hit) this.playerBulletEventHandler() }, 20)
      //every 10ms, do bullet cooldown if bullet is locked
      this.timer = setInterval(() => {
        if(this.playerBulletLock) {
          this.playerBulletCooldown -= 10;
          this.playerBulletLock = !(this.playerBulletCooldown <= 0);
        }
      }, 10)

      // Enemy Timers
      // every 1/50s, move enemy
      this.timer = setInterval(() => {if(!pc.hit) this.enemyMover() }, 20)
      // every 1/5s, determine if enemy fires
      this.timer = setInterval(() => {if(!pc.hit) this.enemyFire() }, 200)
      // every 1/100s, process the hit enemies
      this.timer = setInterval(() => {if(!pc.hit) this.enemyPostHitCuller() }, 10)
      // every 1s, run enemy spawner
      this.timer = setInterval(() => {if(!pc.hit) this.enemySpawner() }, 1000)


      //misc 1/10s timer function to test things
      this.timer = setInterval(() => {
        //console.log(bulletFiredByPress)
        //console.log(keysPressed)
      }, 100)

      //initiate first draw
      this.drawCanvas();


    },
    drawCanvas(){

      // gamescreen
      let cvn = this.$refs.gs;
      cvn.height = canvasTilePerSide * tilesize;
      cvn.width = canvasTilePerSide * tilesize;
      //draw background(s)
      for (let i = 0; i < canvasBackgroundImgs.length; i++) {
        let currentBGIMG = canvasBackgroundImgs[i];
        cvn.getContext("2d").drawImage(currentBGIMG.backgroundImage, 0, currentBGIMG.backgroundY, currentBGIMG.sourceSidePxs, currentBGIMG.sourceSidePxs,
            0, 0, cvn.width, cvn.height);
      }
      //draw playarcharacter
      cvn.getContext("2d").drawImage(pc.sprite, tilesize * pc.playerCoords[0], tilesize * pc.playerCoords[1], tilesize, tilesize);
      //draw enemies
      this.enemyDrawer();
      //draw bullets
      this.bulletDrawer();

      // UIScreen
      cvn = this.$refs.uis;
      cvn.height = canvasTilePerSide * tilesize;
      cvn.width = canvasTilePerSide * tilesize;
      if(pc.hit){
        cvn.getContext("2d").drawImage(gameOverOverlay, 0,0, cvn.width, cvn.height);
      }



      window.requestAnimationFrame(this.drawCanvas);

    },
    gameRestart(){
      //code to run when it is requested for the game to restart
      this.playerBulletLock = false; this.playerBulletCooldown = 0;

      keysPressed = []; //reset keypresses
      this.enemies = []; //clear enemies
      this.enemiesHit = 0;
      bullets = [];
      pc.hit = false; this.playerHit = false;
      pc.playerCoords = [(canvasTilePerSide-1)/2, canvasTilePerSide-1];
      pc.sprite = playerShipImg;
    },
    //utility funcs
    delay(milliseconds){
      return new Promise(resolve => {
        setTimeout(resolve, milliseconds);
      });
    }
  }

}
</script>

<style scoped>

.containerOfAll{
  background-color: MidnightBlue;
  position: fixed;
  right: 0;
  left: 0;
  top: 0;
  bottom: 0;
  font-family:  "Liberation Mono", "Lucida Console", "Courier New", monospace;
}
.controlStuff{
  display: grid;
  position: absolute;
  background-color: DarkOliveGreen;
  color: white;
  right: 0;
  bottom: 0;
  width: 30%;
  border: 3px solid YellowGreen;
  padding: 20px;
  row-gap: 10px;
}
.instructionsForGS{
  border: 3px solid orangered;
  padding: 2%;
}
.controlButtons{
  display: flex;
  border: 3px solid SteelBlue;
  padding: 2%;
  justify-content: center;
  align-content: center;
  column-gap: 5px;
}
.gameData{
  border: 3px solid DarkKhaki;
  padding: 2%;

}
.gamescreen, .UIscreen{
  border: 3px solid LightSlateGray;
  position: absolute;
  display: block;
}


</style>
